import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { CREATE_INGREDIENT_SPECIAL_CASE_MUTATION } from '../graphql/mutations'
import { transformToSaveIngredientSpecialCaseArgs } from '../graphql/transformers'
import { UPSERT_INGREDIENT_SPECIAL_CASE } from '../redux/action-types'

const useCreateIngredientSpecialCaseMutation = () => {
  const dispatch = useDispatch()
  const { isLoading, error } = useSelector(
    store => store.ingredients.ingredientSpecialCase,
  )

  const mutate = useCallback(
    ingredientSpecialCaseData =>
      apolloService.mutate(
        CREATE_INGREDIENT_SPECIAL_CASE_MUTATION,
        {
          data: transformToSaveIngredientSpecialCaseArgs(
            ingredientSpecialCaseData,
          ),
        },
        dispatch,
        UPSERT_INGREDIENT_SPECIAL_CASE,
      ),
    [dispatch],
  )

  return [mutate, { isLoading, error }]
}

export default useCreateIngredientSpecialCaseMutation
